module.exports = __webpack_public_path__ + "730500fad9d407d89eb172bb1ee517ff.fbx";